import { useTranslation } from 'react-i18next';

import { NgButton } from '@/ui';

export type IncidentDetailActionBarItemsProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  onAddAgencyToIncident: () => void | Promise<void>;
  onOpenShareByLinkDialog: () => void | Promise<void>;
  onCloseIncident: () => void | Promise<void>;
};

export function IncidentDetailActionBarItems({
  incidentIsReadOnly,
  onAddAgencyToIncident,
  onOpenShareByLinkDialog,
  onCloseIncident,
}: IncidentDetailActionBarItemsProps) {
  const { t } = useTranslation();

  return (
    <>
      {!incidentIsReadOnly && (
        <NgButton
          text={t('Incident_Button_AddAgencyToIncident')}
          outline
          icon="fal fa-phone-plus"
          testID="incident-share-to-agency-button"
          onClick={onAddAgencyToIncident}
        />
      )}

      <NgButton
        text={t('Incident_Button_ShareViaLink')}
        outline
        icon="fal fa-share-from-square"
        testID="incident-share-with-crew-button"
        onClick={onOpenShareByLinkDialog}
      />

      {!incidentIsReadOnly && (
        <NgButton
          text={t('Incident_Button_CloseIncident')}
          outline
          type="danger"
          icon="fal fa-xmark"
          confirmationMessage={t('Incident_Button_CloseIncident_Confirmation')}
          testID="incident-close-button"
          onClick={onCloseIncident}
          enableMultipleClickPrevention
        />
      )}
    </>
  );
}
